var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIconMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.877,
    height: 29,
    viewBox: "0 0 34.877 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 121",
    transform: "translate(0 4.5)",
    style: {
      stroke: "#e9e7e1",
      fill: "none"
    },
    d: "M0 0h34.877"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 122",
    transform: "translate(0 14.847)",
    style: {
      stroke: "#e9e7e1",
      fill: "none"
    },
    d: "M0 0h34.877"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 123",
    transform: "translate(0 25.346)",
    style: {
      stroke: "#e9e7e1",
      fill: "none"
    },
    d: "M0 0h34.877"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 158",
    transform: "translate(6.241)",
    style: {
      fill: "#222",
      stroke: "#e9e7e1"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 159",
    transform: "translate(21.241 10)",
    style: {
      fill: "#222",
      stroke: "#e9e7e1"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 160",
    transform: "translate(6.241 20)",
    style: {
      fill: "#222",
      stroke: "#e9e7e1"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    style: {
      fill: "none"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconMobile);
export default __webpack_public_path__ + "static/media/filter-icon-mobile.d829b40e967981cedad0f39a3edcb805.svg";
export { ForwardRef as ReactComponent };